module.exports = __webpack_public_path__ + "img/2OOx2OO.d41d8cd9.svg";